export default Object.freeze({
    ONLINE_BANKING_B2C: 1,
    ONLINE_BANKING_B2B: 2,
    CREDIT_CARD: 3,
    TOKENIZATION: 4,
    DUITNOW: 5,
  });